export default "__VITE_ASSET__DHqb7yJB__"